export default __webpack_public_path__ + "assets/images/Real-Time-Payouts-4a1a9e372533d360473f557871cc572c.svg";